<template>
	<section id="sustainability" class="bg-primary-light py-6">
		<b-container>
			<b-row>
				<b-col cols="12" md="9" lg="8" xl="6" class="text-center mx-auto">
					<h2 class="text-white text-uppercase font-weight-bold m-0 pb-3 pb-md-0 pb-lg-3">Hållbart hela vägen</h2>
					<hr class="border-white bold w-5 d-inline-block"/>
					<p class="text-white px-5 px-md-0">Lidls arbete för hållbarare produktion och konsumtion av livsmedel och andra varor utgår från vår värdekedja.</p>
				</b-col>
			</b-row>
			<b-row class="d-none d-lg-block pt-5 pt-md-4 pt-lg-5">
				<b-col cols="12" xl="11" class="mx-auto">
					<b-row>
						<b-col cols="12" md="3" class="px-lg-1 px-xl-4 text-center">
							<a 	href="#materials"
								v-scroll-to="{ el: '#materials', offset: scrollOffset }"
								class="text-decoration-none d-inline-block"
								@mouseover="hoverArea = 'materials'"
								@mouseout="hoverArea = null">
								<div class="position-relative">
									<img src="../assets/img/icons/materials-white.svg" alt="Råvaror och jordbruk" width="200" height="200" class="img-fluid d-inline-block" v-if="hoverArea === 'materials'">
									<img src="../assets/img/icons/materials.svg" alt="Råvaror och jordbruk" width="200" height="200" class="img-fluid d-inline-block" v-else>
									<img src="../assets/img/icons/arrow-right.svg" alt="Pil höger" width="26" height="49" class="icon-arrow">
								</div>
								<p class="m-0 pt-3 font-weight-bold text-uppercase text-center text" :class="hoverArea === 'materials' ? 'text-white' : 'text-primary-dark'">Råvaror <br>och jordbruk</p>
							</a>
						</b-col>
						<b-col cols="12" md="3" class="px-lg-1 px-xl-4 text-center">
							<a 	href="#suppliers"
								v-scroll-to="{ el: '#suppliers', offset: scrollOffset }"
								class="text-decoration-none d-inline-block"
								@mouseover="hoverArea = 'suppliers'"
								@mouseout="hoverArea = null">
								<div class="position-relative">
									<img src="../assets/img/icons/suppliers-white.svg" alt="Leverantörer och produktion" width="200" height="200" class="img-fluid d-inline-block" v-if="hoverArea === 'suppliers'">
									<img src="../assets/img/icons/suppliers.svg" alt="Leverantörer och produktion" width="200" height="200" class="img-fluid d-inline-block" v-else>
									<img src="../assets/img/icons/arrow-right.svg" alt="Pil höger" width="26" height="49" class="icon-arrow">
								</div>
								<p class="m-0 pt-3 font-weight-bold text-uppercase text-center text" :class="hoverArea === 'suppliers' ? 'text-white' : 'text-primary-dark'">Leverantörer <br>och produktion</p>
							</a>
						</b-col>
						<b-col cols="12" md="3" class="px-lg-1 px-xl-4 text-center">
							<a 	href="#coworkers"
								v-scroll-to="{ el: '#coworkers', offset: scrollOffset }"
								class="text-decoration-none d-inline-block"
								@mouseover="hoverArea = 'coworkers'"
								@mouseout="hoverArea = null">
								<div class="position-relative">
									<img src="../assets/img/icons/coworkers-white.svg" alt="Medarbetare och verksamhet" width="200" height="200" class="img-fluid d-inline-block" v-if="hoverArea === 'coworkers'">
									<img src="../assets/img/icons/coworkers.svg" alt="Medarbetare och verksamhet" width="200" height="200" class="img-fluid d-inline-block" v-else>
									<img src="../assets/img/icons/arrow-right.svg" alt="Pil höger" width="26" height="49" class="icon-arrow">
								</div>
								<p class="m-0 pt-3 font-weight-bold text-uppercase text-center text" :class="hoverArea === 'coworkers' ? 'text-white' : 'text-primary-dark'">Medarbetare <br>och verksamhet</p>
							</a>
						</b-col>
						<b-col cols="12" md="3" class="px-lg-1 px-xl-4 text-center">
							<a 	href="#customers"
								v-scroll-to="{ el: '#customers', offset: scrollOffset }"
								class="text-decoration-none d-inline-block"
								@mouseover="hoverArea = 'customers'"
								@mouseout="hoverArea = null">
								<div class="position-relative">
									<img src="../assets/img/icons/customers-white.svg" alt="Kunder och samhälle" width="200" height="200" class="img-fluid d-inline-block" v-if="hoverArea === 'customers'">
									<img src="../assets/img/icons/customers.svg" alt="Kunder och samhälle" width="200" height="200" class="img-fluid d-inline-block" v-else>
								</div>
								<p class="m-0 pt-3 font-weight-bold text-uppercase text-center text" :class="hoverArea === 'customers' ? 'text-white' : 'text-primary-dark'">Kunder <br>och samhälle</p>
							</a>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-container>
	</section>
</template>
<script>
	export default {
		name: 'Sustainability',
		props: {
			pdfLink: {
				default: null
			}
		},
		data () {
			return {
				headerHeight: 0,
				scrollOffset: 0,
				hoverArea: null
			}
		},
		methods: {
			handleResize (e) {
				this.headerHeight = document.getElementById('page-header').offsetHeight;
				this.scrollOffset = -this.headerHeight;
			}
		},
		created () {
			window.addEventListener('resize', this.handleResize);
		},
		mounted() {
			this.headerHeight = document.getElementById('page-header').offsetHeight;
			this.scrollOffset = -this.headerHeight;
		},
		beforeDestroy () {
			window.removeEventListener('resize', this.handleResize);
		}
	}
</script>
